export default "__VITE_ASSET__YChXWRbk__"